export const getStoryblokImageSize = (src: string) => {
  const storyblokRegex = /^(https?:)?\/\/a.storyblok.com\//
  const originalPath = src.replace(storyblokRegex, '')
  const [, , dimensions] = originalPath.split('/')
  const [width, height] = dimensions.split('x').map((num) => parseInt(num, 10))

  return { width, height }
}
